/**
 * InpiFormalityStatusController — bandeau pédagogique D5 dans l'onglet
 * « Activités » (EPIC-006 / 6.4).
 *
 * V1 minimaliste — le bandeau est masqué par défaut (`hidden` dans le HTML
 * statique) et ce controller le révèle dès qu'au moins une activité possède
 * une formalité INPI ouverte (`pendingFormality` non null dans la payload
 * GET /activities, livré 6.3).
 *
 * Pourquoi un controller dédié plutôt que de gérer ça dans `activities-list` :
 *   - Anticipe EPIC-008 / 8.6 qui ajoutera la lecture du statut INPI réel
 *     (`inpiStatus = local | sent | accepted | refused`) et fera évoluer le
 *     bandeau en CTA actif vers procedures.inpi.fr. Cette responsabilité a
 *     vocation à grossir et mérite son propre controller.
 *
 * Synchronisation : le controller écoute `activity-form:saved` pour réagir
 * aux ajouts/édits, et lit le cache exposé par `activities-list` sur l'élément
 * porteur du controller (`__activities`).
 *
 * Conventions :
 *   - 0 HTML inline (juste `hidden = true|false`).
 *   - Aucune classe CSS inventée.
 */

import BaseController from "./base_controller.js";

export default class InpiFormalityStatusController extends BaseController {
  static targets = ["banner"];

  _onActivitiesChanged = null;
  _refreshTimer = null;

  connect() {
    // Re-évalue à chaque save d'activité.
    this._onActivitiesChanged = () => this._scheduleRefresh();
    this.element.addEventListener("activity-form:saved", this._onActivitiesChanged);

    // Première évaluation après que `activities-list` ait fini son fetch
    // initial (qui se fait également au connect). On laisse 1 tick.
    this._scheduleRefresh();
  }

  disconnect() {
    if (this._onActivitiesChanged) {
      this.element.removeEventListener("activity-form:saved", this._onActivitiesChanged);
    }
    if (this._refreshTimer) {
      clearTimeout(this._refreshTimer);
      this._refreshTimer = null;
    }
  }

  _scheduleRefresh() {
    if (this._refreshTimer) clearTimeout(this._refreshTimer);
    // 100ms : laisse le temps à activities-list de finir son refresh.
    this._refreshTimer = setTimeout(() => this._refresh(), 100);
  }

  _refresh() {
    if (!this.hasBannerTarget) return;

    const root = document.querySelector("[data-controller~='activities-list']");
    const activities = (root && root.__activities) || [];

    const hasOpenFormality = activities.some(
      (a) => a && a.status === "active" && a.pendingFormality,
    );

    this.bannerTarget.hidden = !hasOpenFormality;
  }
}
